import { TriggerCategory } from "@redotech/redo-shopper-agent-common/trigger-definition";
import * as z from "zod";

export const bulkEnableShopperAgentCategory = {
  name: "bulkEnableShopperAgentCategory" as const,
  input: z.object({
    categories: z.array(z.enum(TriggerCategory)).min(1),
    stageDraft: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
